import React from "react";
import Tooltip from "./Tooltip";

const getStatusStyles = (status, variant) => {
  const statusLower = status?.toLowerCase();

  // For EMAIL MODE and SMS MODE badges
  if (variant === "email" || variant === "sms") {
    switch (statusLower) {
      case "enabled":
        return "bg-success/10 text-success";
      case "disabled":
        return "bg-statsRed/10 text-statsRed";
      case "notification":
        return "bg-statsOrange/10 text-statsOrange";
      default:
        return "bg-content/10 text-content";
    }
  }

  // Default variant (for logs status)
  switch (statusLower) {
    case "delivered":
      return "bg-[#DBFCE7] text-success";
    case "not delivered":
      return "bg-[#2D374833] text-content";
    case "failed":
      return "bg-[#F4B2B2] text-statsRed";
    case "processing":
      return "bg-[#FBF1E1] text-statsOrange";
    case "pending":
      return "bg-[#FBF1E1] text-statsOrange";
    case "draft":
      return "bg-[#2D374833] text-content";
    case "open":
      return "bg-[#E0F2FE] text-[#0369A1]";
    case "suspended":
      return "bg-statsRed/10 text-statsRed";
    case "paid":
      return "bg-[#DBFCE7] text-success";
    case "uncollectible":
      return "bg-[#F4B2B2] text-statsRed";
    case "void":
      return "bg-statsRed/10 text-statsRed";
    case "active":
      return "bg-[#DBFCE7] text-success";
    case "expired":
      return "bg-statsRed/10 text-statsRed";
    case "inactive":
      return "bg-statsRed/10 text-statsRed";
    default:
      return "bg-[#2D374833] text-content";
  }
};

const getTooltipText = (status) => {
  switch (status?.toLowerCase()) {
    case "delivered":
      return "Message delivered to all selected modes";
    case "failed":
      return "Message not delivered to at least one mode";
    case "processing":
      return "Message received and being processed";
    case "not delivered":
      return "Message not delivered to any mode";
    default:
      return "";
  }
};

const StatusBadge = ({ status, variant = "default" }) => {
  const badge = (
    <span
      className={`inline-flex items-center px-3 py-2 rounded-md text-xs font-semibold whitespace-nowrap ${getStatusStyles(
        status,
        variant,
      )}`}
    >
      {status}
    </span>
  );
  const tooltipText = getTooltipText(status);
  return tooltipText ? <Tooltip text={tooltipText}>{badge}</Tooltip> : badge;
};

export default StatusBadge;
